import badwords from './offensive-words.data';

interface UserField {
	name: string;
	value: string;
}

export const unacceptableInputs = (inputs: UserField[]) => {
	let inputsToTest = inputs.map((input) => ({ ...input, value: input.value.toLocaleLowerCase() }));
	const unacceptableFieldNames: string[] = [];

	for (const word of badwords) {
		if (!inputsToTest.length) {
			break;
		}

		inputsToTest.forEach((input) => {
			if (input.value === word) {
				unacceptableFieldNames.push(input.name);
				inputsToTest = inputsToTest.filter((testInput) => testInput.name !== input.name);
			}
		});
	}

	return unacceptableFieldNames;
};
